const SKIP_DELETE_MODAL_TYPES = {
  SKIP: 'SKIP',
  DELETE: 'DELETE',
  FREQUENCY_CHANGE: 'FREQUENCY_CHANGE',
  DATE_CHANGE: 'DATE_CHANGE',
}

export { SKIP_DELETE_MODAL_TYPES }
